export default __webpack_public_path__ + "static/media/36.47f2ad61.webp";